import jQuery from 'jquery';

window.$ = window.jQuery = jQuery;
require('bootstrap/dist/js/bootstrap.bundle.min.js');
